"use client";

import { Quote } from "lucide-react";
import React from "react";

import type { Feedback } from "@/payload-types";

type Props = {
  feedback: Feedback;
};

export const CardTestimonial = ({ feedback }: Props) => {
  return (
    <div className="mt-4 flex w-full flex-col items-center rounded-md border bg-white px-6 py-9 shadow-md transition-transform duration-500 hover:-translate-y-4">
      <Quote size={64} className="mb-2 text-gray-200" />
      <p className="mb-8 font-serif text-[1.2rem] font-light italic leading-relaxed text-gray-800 line-clamp-[10]">
        {feedback.messages}
      </p>
      <div className="mt-2 text-base font-medium text-gray-700 md:text-lg">
        {feedback.name}
      </div>
    </div>
  );
};
